window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
 */
site.ScrollTo = (function ScrollTo() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Smooth Scroll to href component
    const scrollerDataAttr = document.querySelectorAll('[data-scroll]');

    scrollerDataAttr.forEach(btn => {
      let scrollerDataAttr = 'data-scroll';

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        if (e.target.getAttribute(scrollerDataAttr) !== '') {
          return
        }

        const $target = document.querySelector(e.target.getAttribute('href'));
        $target.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

      });
    });



    return true;

  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
